import { DisplayColumn } from '../components/data-table/data-table.component'

export const keyingDisplayColumns: DisplayColumn[] = [
  {
    property: 'name',
    type: 'text',
    title: 'Job Name',
    sortDirection: 0,
    searchText: null,
    default: true,
    defaultOrder: 0,
    editable: false,
    required: false,
    createOrder: 0,
    defaultValue: false,
    options: [],
    textArea: false,
  },
  {
    property: 'createdBy',
    type: 'text',
    title: 'Active User',
    sortDirection: 0,
    searchText: null,
    default: true,
    defaultOrder: 0,
    editable: false,
    required: false,
    createOrder: 0,
    defaultValue: false,
    options: [],
    textArea: false,
  },
  {
    property: 'structureNumber',
    type: 'text',
    title: 'Structure Number',
    sortDirection: 0,
    searchText: null,
    default: true,
    defaultOrder: 0,
    editable: false,
    required: false,
    createOrder: 0,
    defaultValue: false,
    options: [],
    textArea: false,
  },
  {
    property: 'city',
    type: 'text',
    title: 'City',
    sortDirection: 0,
    searchText: null,
    default: true,
    defaultOrder: 0,
    editable: false,
    required: false,
    createOrder: 0,
    defaultValue: false,
    options: [],
    textArea: false,
  },
  {
    property: 'stateCode',
    type: 'text',
    title: 'State',
    sortDirection: 0,
    searchText: null,
    default: true,
    defaultOrder: 0,
    editable: false,
    required: false,
    createOrder: 0,
    defaultValue: false,
    options: [],
    textArea: false,
  },
  {
    property: 'countryCode',
    type: 'text',
    title: 'Country',
    sortDirection: 0,
    searchText: null,
    default: true,
    defaultOrder: 0,
    editable: false,
    required: false,
    createOrder: 0,
    defaultValue: false,
    options: [],
    textArea: false,
  },
  {
    property: 'tmkName',
    type: 'text',
    title: 'TMK Name',
    sortDirection: 0,
    searchText: null,
    default: true,
    defaultOrder: 0,
    editable: false,
    required: false,
    createOrder: 0,
    defaultValue: false,
    options: [],
    textArea: false,
  },
  {
    property: 'tmkKeyway',
    type: 'text',
    title: 'TMK Keyway',
    sortDirection: 0,
    searchText: null,
    default: true,
    defaultOrder: 0,
    editable: false,
    required: false,
    createOrder: 0,
    defaultValue: false,
    options: [],
    textArea: false,
  },
  {
    property: 'keywayFamily',
    type: 'text',
    title: 'Keyway Family',
    sortDirection: 0,
    searchText: null,
    default: true,
    defaultOrder: 0,
    editable: false,
    required: false,
    createOrder: 0,
    defaultValue: false,
    options: [],
    textArea: false,
  },
  {
    property: 'pinCount',
    type: 'text',
    title: 'Pin Count',
    sortDirection: 0,
    searchText: null,
    default: true,
    defaultOrder: 0,
    editable: false,
    required: false,
    createOrder: 0,
    defaultValue: false,
    options: [],
    textArea: false,
  },
]

export const keySystemDisplayColumns: DisplayColumn[] = [
  {
    property: 'topMasterKeyName',
    type: 'text',
    title: 'TMK Name',
    sortDirection: 0,
    searchText: null,
    default: true,
    defaultOrder: 0,
    editable: false,
    required: false,
    createOrder: 0,
    defaultValue: false,
    options: [],
    textArea: false,
  },
  {
    property: 'topMasterKey',
    type: 'text',
    title: 'TMK Bitting',
    sortDirection: 0,
    searchText: null,
    default: true,
    defaultOrder: 0,
    editable: false,
    required: false,
    createOrder: 0,
    defaultValue: false,
    options: [],
    textArea: false,
  },
  {
    property: 'keySectionName',
    type: 'text',
    title: 'TMK Key Section',
    sortDirection: 0,
    searchText: null,
    default: true,
    defaultOrder: 0,
    editable: false,
    required: false,
    createOrder: 0,
    defaultValue: false,
    options: [],
    textArea: false,
  },
  {
    property: 'hasUnverifiedKeys',
    type: 'text',
    title: 'Unverified Keys',
    sortDirection: 0,
    searchText: null,
    default: true,
    defaultOrder: 0,
    editable: false,
    required: false,
    createOrder: 0,
    defaultValue: false,
    options: [],
    textArea: false,
  },
  {
    property: 'hasUnverifiedCylinders',
    type: 'text',
    title: 'Unverified Cylinders',
    sortDirection: 0,
    searchText: null,
    default: true,
    defaultOrder: 0,
    editable: false,
    required: false,
    createOrder: 0,
    defaultValue: false,
    options: [],
    textArea: false,
  },
]

// {
//   property: 'constructionTypeId',
//   type: 'text',
//   title: 'Construction Key Name',
//   sortDirection: 0,
//   searchText: null,
//   default: true,
//   defaultOrder: 0,
//   editable: false,
//   required: false,
//   createOrder: 0,
//   defaultValue: false,
//   options: [],
//   textArea: false,
// },
// {
//   property: 'statusId',
//   type: 'text',
//   title: 'Status',
//   sortDirection: 0,
//   searchText: null,
//   default: true,
//   defaultOrder: 0,
//   editable: false,
//   required: false,
//   createOrder: 0,
//   defaultValue: false,
//   options: [],
//   textArea: false,
// },
// {
//   property: 'createdOn',
//   type: 'text',
//   title: 'Created On',
//   sortDirection: 0,
//   searchText: null,
//   default: true,
//   defaultOrder: 0,
//   editable: false,
//   required: false,
//   createOrder: 0,
//   defaultValue: false,
//   options: [],
//   textArea: false,
// },

export const keyways = ['145', '137']

export const NotesAndKeysDisplayColumns: DisplayColumn[] = [
  {
    property: 'user',
    type: 'text',
    title: 'User Name',
    sortDirection: 0,
    searchText: null,
    default: true,
    defaultOrder: 0,
    editable: false,
    required: false,
    createOrder: 0,
    defaultValue: false,
    options: [],
    textArea: false,
  },
  {
    property: 'date',
    type: 'text',
    title: 'Date',
    sortDirection: 0,
    searchText: null,
    default: true,
    defaultOrder: 0,
    editable: false,
    required: false,
    createOrder: 0,
    defaultValue: false,
    options: [],
    textArea: false,
  },
  {
    property: 'description',
    type: 'text',
    title: 'Description',
    sortDirection: 0,
    searchText: null,
    default: true,
    defaultOrder: 0,
    editable: false,
    required: false,
    createOrder: 0,
    defaultValue: false,
    options: [],
    textArea: false,
  },
  {
    property: 'reason',
    type: 'text',
    title: 'Reason',
    sortDirection: 0,
    searchText: null,
    default: true,
    defaultOrder: 0,
    editable: false,
    required: false,
    createOrder: 0,
    defaultValue: false,
    options: [],
    textArea: false,
  },
  {
    property: 'keyName',
    type: 'text',
    title: 'Key Name',
    sortDirection: 0,
    searchText: null,
    default: true,
    defaultOrder: 0,
    editable: false,
    required: false,
    createOrder: 0,
    defaultValue: false,
    options: [],
    textArea: false,
  },
  {
    property: 'previous',
    type: 'text',
    title: 'Previous',
    sortDirection: 0,
    searchText: null,
    default: true,
    defaultOrder: 0,
    editable: false,
    required: false,
    createOrder: 0,
    defaultValue: false,
    options: [],
    textArea: false,
  },
  {
    property: 'new',
    type: 'text',
    title: 'New',
    sortDirection: 0,
    searchText: null,
    default: true,
    defaultOrder: 0,
    editable: false,
    required: false,
    createOrder: 0,
    defaultValue: false,
    options: [],
    textArea: false,
  },
]

export const CylinderPinningsDisplayColumns: DisplayColumn[] = [
  {
    property: 'user',
    type: 'text',
    title: 'User Name',
    sortDirection: 0,
    searchText: null,
    default: true,
    defaultOrder: 0,
    editable: false,
    required: false,
    createOrder: 0,
    defaultValue: false,
    options: [],
    textArea: false,
  },
  {
    property: 'date',
    type: 'text',
    title: 'Date',
    sortDirection: 0,
    searchText: null,
    default: true,
    defaultOrder: 0,
    editable: false,
    required: false,
    createOrder: 0,
    defaultValue: false,
    options: [],
    textArea: false,
  },
  {
    property: 'reason',
    type: 'text',
    title: 'Reason',
    sortDirection: 0,
    searchText: null,
    default: true,
    defaultOrder: 0,
    editable: false,
    required: false,
    createOrder: 0,
    defaultValue: false,
    options: [],
    textArea: false,
  },
  {
    property: 'comment',
    type: 'text',
    title: 'Comment',
    sortDirection: 0,
    searchText: null,
    default: true,
    defaultOrder: 0,
    editable: false,
    required: false,
    createOrder: 0,
    defaultValue: false,
    options: [],
    textArea: false,
  },
  {
    property: 'cylinderName',
    type: 'text',
    title: 'Cylinder Name',
    sortDirection: 0,
    searchText: null,
    default: true,
    defaultOrder: 0,
    editable: false,
    required: false,
    createOrder: 0,
    defaultValue: false,
    options: [],
    textArea: false,
  },
  {
    property: 'previous',
    type: 'text',
    title: 'Previous',
    sortDirection: 0,
    searchText: null,
    default: true,
    defaultOrder: 0,
    editable: false,
    required: false,
    createOrder: 0,
    defaultValue: false,
    options: [],
    textArea: false,
  },
  {
    property: 'new',
    type: 'text',
    title: 'New',
    sortDirection: 0,
    searchText: null,
    default: true,
    defaultOrder: 0,
    editable: false,
    required: false,
    createOrder: 0,
    defaultValue: false,
    options: [],
    textArea: false,
  },
]

export const DeletedKeysDisplayColumns: DisplayColumn[] = [
  {
    property: 'user',
    type: 'text',
    title: 'User Name',
    sortDirection: 0,
    searchText: null,
    default: true,
    defaultOrder: 0,
    editable: false,
    required: false,
    createOrder: 0,
    defaultValue: false,
    options: [],
    textArea: false,
  },
  {
    property: 'date',
    type: 'text',
    title: 'Date',
    sortDirection: 0,
    searchText: null,
    default: true,
    defaultOrder: 0,
    editable: false,
    required: false,
    createOrder: 0,
    defaultValue: false,
    options: [],
    textArea: false,
  },
]

export const OverridesDisplayColumns: DisplayColumn[] = [
  {
    property: 'user',
    type: 'text',
    title: 'User Name',
    sortDirection: 0,
    searchText: null,
    default: true,
    defaultOrder: 0,
    editable: false,
    required: false,
    createOrder: 0,
    defaultValue: false,
    options: [],
    textArea: false,
  },
  {
    property: 'date',
    type: 'text',
    title: 'Date',
    sortDirection: 0,
    searchText: null,
    default: true,
    defaultOrder: 0,
    editable: false,
    required: false,
    createOrder: 0,
    defaultValue: false,
    options: [],
    textArea: false,
  },
]

export const CylindersDisplayColumns: DisplayColumn[] = [
  {
    property: 'name',
    type: 'text',
    title: 'Name',
    sortDirection: 0,
    searchText: null,
    default: true,
    defaultOrder: 0,
    editable: false,
    required: false,
    createOrder: 0,
    defaultValue: false,
    options: [],
    textArea: false,
  },
  {
    property: 'keywayName',
    type: 'text',
    title: 'Key Section',
    sortDirection: 0,
    searchText: null,
    default: true,
    defaultOrder: 0,
    editable: false,
    required: false,
    createOrder: 0,
    defaultValue: false,
    options: [],
    textArea: false,
  },
  {
    property: 'bitting',
    type: 'text',
    title: 'Bitting',
    sortDirection: 0,
    searchText: null,
    default: true,
    defaultOrder: 0,
    editable: false,
    required: false,
    createOrder: 0,
    defaultValue: false,
    options: [],
    textArea: false,
  },
  {
    property: 'keyFunction',
    type: 'text',
    title: 'Key Function',
    sortDirection: 0,
    searchText: null,
    default: true,
    defaultOrder: 0,
    editable: false,
    required: false,
    createOrder: 0,
    defaultValue: false,
    options: [],
    textArea: false,
  },
]

export const OrderHistoryDisplayColumns: DisplayColumn[] = [
  {
    property: 'orderNumber',
    type: 'text',
    title: 'Order Number',
    sortDirection: 0,
    searchText: null,
    default: true,
    defaultOrder: 0,
    editable: false,
    required: false,
    createOrder: 0,
    defaultValue: false,
    options: [],
    textArea: false,
  },
  {
    property: 'user',
    type: 'text',
    title: 'User',
    sortDirection: 0,
    searchText: null,
    default: true,
    defaultOrder: 0,
    editable: false,
    required: false,
    createOrder: 0,
    defaultValue: false,
    options: [],
    textArea: false,
  },
  {
    property: 'date',
    type: 'text',
    title: 'Date',
    sortDirection: 0,
    searchText: null,
    default: true,
    defaultOrder: 0,
    editable: false,
    required: false,
    createOrder: 0,
    defaultValue: false,
    options: [],
    textArea: false,
  },
]
